import React from 'react';
import { Box, Paper, styled } from '@mui/material';
import PlanPage from '../../pages/customer/PlanPage';

const PreviewContainer = styled(Paper)`
  transform: scale(0.8);
  transform-origin: top left;
  width: 125%; // 1/0.8 = 125% to maintain content size after scale
  overflow: hidden;
  border: 1px solid ${props => props.theme.palette.divider};
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const ScrollContainer = styled(Box)`
  width: 100%;
  height: 100%;
  overflow: auto;
`;

interface PreviewPlanPageProps {
  expertUrl?: string;
}

export default function PreviewPlanPage({ expertUrl = 'preview' }: PreviewPlanPageProps) {
  return (
    <PreviewContainer>
      <PlanPage isPreview expertUrl={expertUrl} />
    </PreviewContainer>
  );
}
